import {useContext} from 'react';
import ObservabilityConfigContext from 'src/internal/config/ObservabilityConfigContext';

import type {ObservabilityConfig} from 'src/types';

/**
 * @see https://sail.stripe.me/apis/observability/useObservabilityConfig
 */
export default function useObservabilityConfig(): ObservabilityConfig {
  return useContext(ObservabilityConfigContext);
}
